import {Box} from '@mui/material';
import React, {useState} from 'react';

import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomSelectField from '../../../components/CustomFormFields/CustomSelectField/CustomSelectField';
import {refreshConfig} from '../../../service/admin';
import {handleError} from '../../../utils/errors';

const ConfigMongo = ({setSnackBarAlert, setIsLoading}) => {
  const [formData, setFormData] = useState({
    appName: {
      type: 'select',
      label: 'App',
      value: 'ois',
      options: [
        {code: 'ois', label: 'ois'},
        {code: 'moss', label: 'moss'},
        {code: 'menu_uptime', label: 'menu uptime'},
      ],
      error: false,
      hide: false,
      helperText: '',
    },
  });

  const handleButtonClick = async (e) => {
    try {
      setIsLoading(true);
      await refreshConfig(formData.appName.value);
      setSnackBarAlert((prevState) => ({
        ...prevState,
        isOpen: true,
        message: 'Refresh Successful.',
        severity: 'success',
      }));
    } catch (error) {
      setSnackBarAlert((prevState) => ({
        ...prevState,
        isOpen: true,
        message: handleError(error),
        severity: 'error',
      }));
    } finally {
      setIsLoading(false);
    }
  };
  const handleFormChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.id]: {
        ...prevFormData[e.target.id],
        value: e.target.value,
        error: false,
        helperText: '',
      },
    }));
  };

  return (
    <>
      <Box sx={{p: 3, display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
        {formData &&
          Object.keys(formData)?.map((key, index) => {
            if (!formData[key].hide && formData[key].type === 'select') {
              return (
                <CustomSelectField
                  key={key}
                  id={key}
                  label={formData[key].label}
                  disabled={formData[key].disabled}
                  options={formData[key].options}
                  value={formData[key]?.value}
                  onChange={handleFormChange}
                  error={formData[key]?.error}
                  helperText={formData[key].helperText || ''}
                />
              );
            }
            return null;
          })}
        <br />
      </Box>
      <Box sx={{display: 'flex', flexDirection: 'column', padding: '2rem'}}>
        <CustomButton text={'Refresh'} onClick={handleButtonClick} />
      </Box>
    </>
  );
};

export default ConfigMongo;
